/**
 * PATH: apps/qa/src/pages/template-detail/types.ts
 * PURPOSE: Types for template detail page
 */

export interface TemplateSection {
  id?: string
  _localId?: string
  title: string
  section_number: string
  description?: string
  sort_order: number
  items: TemplateItem[]
}

export interface TemplateItem {
  id?: string
  _localId?: string
  title: string
  item_number: string
  product?: string
  parent?: string | null
  requirement_text: string
  acceptance_criteria: string
  has_hold_point: boolean
  hold_point_config: Record<string, unknown>
  evidence_rules: Record<string, unknown>
  responsible_role: string
  dependencies: string[]
  risk_rating: '' | 'low' | 'medium' | 'high' | 'critical'
  is_active: boolean
}

export const generateLocalId = () => `local-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
export const getSectionId = (section: TemplateSection, index: number) => section.id || section._localId || `section-${index}`
export const getItemId = (item: TemplateItem, sectionIndex: number, itemIndex: number) =>
  item.id || item._localId || `item-${sectionIndex}-${itemIndex}`
